import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_CALENDAR } from "./paths";
import AuthGuard from "../guards/AuthGuard";

const Calendar = lazy(() => import("@pages/calendar"));

const calendarRoutes = [
  {
    path: PATH_CALENDAR,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Calendar />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
  },
];

export default calendarRoutes;
